import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(6),
    minHeight: '60vh'
  },
  icon: {
    fontSize: 64,
    color: theme.palette.grey[500]
  },
  title: { fontWeight: 600 },
  body: { color: theme.palette.grey[700], maxWidth: 480 }
}))

export default useStyles
